import {Component, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessagingService } from '../../../services/messaging.service';
import { StationService } from '../../../services/stations.service';
import {StatsService} from '../../../services/stats.service';
import { SysUsersService } from '../../../services/sys-users.service';
const Lockr = require("lockr");
@Component({
  selector: 'ngx-indicators',
  templateUrl: './indicators.component.html',
})
export class IndicatorsComponent implements OnInit {
  stationId: string;
  accountId: string;
  isSuperAdmin: boolean = false;
  showPanel: boolean = false;
  message;
  user: {
    email: '',
    name: '',
  };

  loading: boolean = false;
  dependence_stats: Array<any> = [];
  general = {
    totalDelivered: 0,
    totalRequirements: 0,
    percentage: 0,
  };
  colorScheme: any;
  themeSubscription: any;
  series = [67];
  chart = {
    type: 'radialBar',
  };
  fill = {
    type: 'gradient',
    gradient: {
      shade: 'dark',
      type: 'horizontal',
      shadeIntensity: 0.5,
      gradientToColors: ['#ABE5A1'],
      inverseColors: true,
      opacityFrom: 1,
      opacityTo: 1,
      stops: [0, 100],
    },
  };
  plotOptions = {
    radialBar: {
      hollow: {
        margin: 15,
        size: '70%',
        image: 'https://image.flaticon.com/icons/svg/2720/2720750.svg',
        imageWidth: 40,
        imageHeight: 40,
        imageClipped: false,
        borderRadius: '50%',
      },
      track: {
        background: '#EBEDEF',
      },
      dataLabels: {
        name: {
          show: false,
          color: '#fff',
        },
        value: {
          show: true,
          color: '#AA4938',
          offsetY: 45,
          fontSize: '16px',
          fontWeight: 'bold',
        },
      },
    },
  };
  dataLoaded = false;

  constructor(

    private statsService: StatsService,
    private stationService: StationService,
    private route: ActivatedRoute,
    private userService: SysUsersService,
    private messagingService: MessagingService
  ) {
    this.stationId =  this.route.snapshot.params.stationId;

    this.stationService.change.subscribe(async (station: any) => {
      this.stationId = station;
      this.init();
    });
  }

  async ngOnInit() {
    this.stationService.checkIfStationIdOrRefirect();
    this.init();
  }

  async init() {
    await this.getUserData();

    const user = Lockr.get('user');
    if (user.account) {
      this.accountId = user.account;
    } else {
      this.accountId = user.user_id;
      this.isSuperAdmin = true;
    }

    const [error, { data: userData }] = await this.userService.getProfile(this.accountId, this.isSuperAdmin);
    this.user.name = userData.name.split(' ')[0];
    if (error) return error;
    this.showPanel = (userData.hasOwnProperty('signature') && userData.signature !== '');
    this.messagingService.requestPermission();
    this.messagingService.receiveMessage();
    this.message = this.messagingService.currentMessage;

    this.stationId = await this.stationService.getActiveStation();
    this.dependence_stats = [];
    await this.getStats();
  }

  async getStats() {
    this.loading = true;
    let totalRequirements = 0;
    let totalDelivered = 0;
    const [error, {data: stats}] = await this.statsService.getStats(this.stationId) as any;
    this.dependence_stats = [];
    if (error) return error;
    for (const stat of stats) {
      totalRequirements += stat.total_requirements;
      totalDelivered += stat.total_delivered;
      const percentage = await this.calculatePercentage(stat.total_delivered, Number(stat.total_requirements));
      this.dependence_stats.push({
        ...stat,
        percentage,
        serie: [percentage],
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 15,
              size: '70%',
              image: stat.logo,
              imageWidth: 40,
              imageHeight: 40,
              imageClipped: false,
              borderRadius: '50%',
            },
            track: {
              background: '#EBEDEF',
            },
            dataLabels: {
              name: {
                show: false,
                color: '#fff',
              },
              value: {
                show: true,
                color: '#AA4938',
                offsetY: 35,
                fontSize: '13px',
                fontWeight: 'bold',
              },
            },
          },
        },
        data: [
          {
            name: 'Entregados',
            value: stat.total_delivered,
          },
          {
            name: 'Sin entregar',
            value: Number(stat.total_requirements) - Number(stat.total_delivered),
          },
        ],
      });
    }
    this.general.totalDelivered = totalDelivered;
    this.general.totalRequirements = totalRequirements;
    this.general.percentage = await this.calculatePercentage(totalDelivered, totalRequirements);
    this.loading = false;
  }

  async calculatePercentage(value: number, total: number) {
    return Math.round((value * 100) / total);
  }

  async getUserData() {
    this.user = Lockr.get('user');
  }
}
